(function () {
  var buttons = document.querySelectorAll('[data-collection-back-to-top]');

  buttons.forEach(function (button) {
    var hasNextPage = button.dataset.collectionHasNext === 'true';
    var paginationStyle = button.dataset.collectionPaginationStyle;
    var loadMore = button.closest('.collection__container')?.querySelector('.js-btn-load-more');

    function updateVisibility() {
      var hasPendingPage = paginationStyle === 'load_more'
        ? Boolean(loadMore?.dataset.href)
        : hasNextPage;
      button.closest('.collection__back-to-top').hidden = hasPendingPage;
    }

    updateVisibility();

    if (paginationStyle === 'load_more' && loadMore) {
      new MutationObserver(updateVisibility).observe(loadMore, { attributes: true, attributeFilter: ['data-href'] });
    }

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}());